// extracted by mini-css-extract-plugin
export default {"container":"ModalContainer_container__7gRaf","ovelay":"ModalContainer_ovelay__e2UNc"};